import React, { Component } from 'react';

// import Circles from '../../components/Circles';
import Cards from '../../components/Cards';

// import ScrollTop from '../../components/ScrollTop';
import Footer from '../../components/Footer';
import FooterCover from '../../components/FooterCover';
import ProgressTalk from '../../components/ProgressTalk';
import HeightSlider from '../../components/HeightSlider';
import ScrollDown from '../../components/ScrollDown';
import Socials from '../../components/Socials';
import PathContext from "../../context/path";
import styles from './Talk.module.sass';
// import './img/main.bg.png';

class Talk extends Component {
	state = {
		bodyOffset: false
	}
	static contextType = PathContext;
	path = this.context;
	refWrap = React.createRef();

	componentDidMount() {
		window.scrollTo(0, 0);
		this.setHeight = this.setHeight.bind(this);
		this.setHeight();
		window.addEventListener('resize', this.setHeight);

	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.setHeight, false);
	}
	setHeight() {
		let vh = window.innerHeight * 0.01;
		this.refWrap.current.style.setProperty('--vh', `${vh}px`);
	}

	render() {

		let sliderHeight = 4;
		if (window.innerWidth > 767) {
			sliderHeight = 2;
		} else {
			sliderHeight = 4;
		}
		return <div ref={this.refWrap} className={styles.wrap}>

			{/* BG */}
			<div className={styles.bg1}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/talk-bg-desktop.png`} />
					<img src={`${this.path}/img/talk-bg.png`} alt="" />
				</picture>
			</div>
			<div className={styles.bg2}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/talk-bg2-desktop.png`} />
					<img src={`${this.path}/img/talk-bg2.png`} alt="" />
				</picture>
			</div>
			<div className={styles.cover}>
				<div className="container">
					<h1 className={styles.title}>
					How do you talk about HIV and why is it crucial that you do so?
					</h1>
					<div className={styles.subtitle}   data-aos="fade-up">

					How to convince your partner to do the test
					</div>
					<div className={styles.img}>
						<img src={`${this.path}/img/gifs/icon4.gif`} alt="" />
					</div>
					<div className={styles.socials}>
						<Socials suffix={'blue'} />
					</div>
				</div>
				<ScrollDown />
			</div>
			<div className={styles.info}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2>Knowing about the virus is the first step</h2>
					<div className={styles.text_1}>
						<p>You may find it awkward or uncomfortable to talk about prevention or tests for various sexually transmitted infections — you may be afraid of offending your partner or of getting a reputation as someone who’s overly cautious or mistrustful.</p>
						<p>If that’s the case, you have to put care for your health at the center of the equation.</p>
					</div>
					</div>
					<div className={styles.lead} data-aos="fade-up">HIV became a serious problem because people were embarrassed to talk about it</div>
					<div data-aos="fade-up">
					<h2>Putting knowledge into practice</h2>
					<div className={styles.text_2}>
						<p>“Test culture” is already well-developed in America and Europe but, in Russia, asking for a test result before engaging in intercourse isn’t customary.</p>
						<p>How to suggest to your partner that they take the test without offending them — recommendations from consultants at the AIDS.CENTER Foundation.</p>
					</div>
					</div>
				</div>
			</div>
			<div className={styles.progress}>
				<HeightSlider height={sliderHeight} detailProgress={true}>
					<ProgressTalk />
				</HeightSlider>
			</div>
			<div className={styles.info_2}   data-aos="fade-up">
				<div className="container">
					<div className={styles.text_3}>
					<p>Remember that no one is obliged to reveal their HIV status — it’s a voluntary decision.</p>
						<p>In just the same way, no one is obliged to have sex without a condom — that’s another voluntary decision that we recommend that you only take if you have complete confidence in your safety and remember to take an HIV test annually (or, if one of the partners is HIV positive, if a certain load level is reached).
						</p>
					</div>
					{/* <div className={styles.desc}><span>*</span>Если один из партнеров ВИЧ-положительный — при достижении неопределяемой вирусной нагрузки.</div> */}
				</div>
			</div>
			<div className={styles.info_3}   data-aos="fade-up">
				<div className="container">
					<h2>Find out your HIV status anonymously in 15 minutes</h2>
					<div className={styles.text_4}>
					Today, HIV is an easily controlled chronic illness. You can live a long, fulfilling life with HIV. You just have to get therapy, which is actually free — the government pays for it. In order to stop the pandemic, we all need to know our HIV status and to get help if that status is positive.
					</div>

				</div>
			</div>
			<div className={styles.faq}>

				<div className="container">
				<div className={styles.footer_cover}>

					<FooterCover />

				</div>
				<div className={styles.cards}>
					<Cards />
				</div>
			</div>
		</div>

		{/* <ScrollTop color={'blue'} /> */ }
		<div className={styles.footer}>
			<Footer />
		</div>
		</div >;
	}
}

export default Talk;
